import { useCallback } from 'react';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';

import { FavoriteStar } from 'src/assets/icons/FavoriteStar';

export const FavoriteProjectIndicator = ({ project, onFavoriteClick, className }) => {
  const onClick = useCallback(() => {
    onFavoriteClick(project.id);
  }, [project, onFavoriteClick]);

  return (
    <IconButton
      className={className}
      onClick={onClick}
    >
      <FavoriteStar full={project.favorite} />
    </IconButton>
  );
};

FavoriteProjectIndicator.propTypes = {
  project: PropTypes.object.isRequired,
  onFavoriteClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

FavoriteProjectIndicator.defaultProps = {
  className: null,
};
